import React, { FC } from 'react';

import { IArticleSubNavTitle } from './model';

const ArticleSubNavTitle: FC<IArticleSubNavTitle> = ({ title }) => <h2>{title}</h2>;

export default ArticleSubNavTitle;
